<div class="confirm-page">
    <div class="confirm-card">
        <img
            [src]="navLogoIconUrl"
            alt="EnvHeaven"
            class="confirm-logo"
            (error)="onLogoError($event)"
        />

        @if (status === "success") {
            <div class="confirm-content">
                <div class="confirm-icon confirm-icon--success">&#10003;</div>
                <h1>Email Confirmed!</h1>
                <p>
                    You're on the EnvHeaven waitlist. We'll reach out when
                    something meaningful is ready.
                </p>
            </div>
        }

        @if (status === "already") {
            <div class="confirm-content">
                <div class="confirm-icon confirm-icon--info">&#9432;</div>
                <h1>Already Confirmed</h1>
                <p>This email has already been confirmed. You're all set!</p>
            </div>
        }

        @if (status === "invalid") {
            <div class="confirm-content">
                <div class="confirm-icon confirm-icon--error">&#10007;</div>
                <h1>Invalid Link</h1>
                <p>
                    This confirmation link is invalid or has expired. Please try
                    signing up again.
                </p>
            </div>
        }

        @if (status === "unknown") {
            <div class="confirm-content">
                <div class="confirm-icon confirm-icon--error">&#10007;</div>
                <h1>Something Went Wrong</h1>
                <p>We could not process your confirmation. Please try again.</p>
            </div>
        }

        <a routerLink="/" class="confirm-btn">Back to Home</a>
    </div>
</div>
